import { CONDO_CORP_NAME } from './../lib/constants';
import { AppThunk } from './store';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { get as _get, isEmpty } from 'lodash';
import analytics from '../lib/wrapAnalytics';
import {
  getUserProfileAPI,
  getServiceRequestAPI,
  registerPushNotificationAPI,
  subscribePushNotificationAPI,
  getPropertyConfig,
  getHomePropertyConfig,
  getZipcode,
  getServiceRequestConfig,
  ServiceRequestConfig,
} from '../api/adserver';

const debug = require('debug')('se:appSlice');

import { RootState } from './rootReducer';
// import { loadBuilding, submitCode } from './buildingSelectionSlice';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Constant from '../lib/constants';
import { Auth } from 'aws-amplify';
import { RootModalProps } from '../components/RootOverlays';
import AxiosInstance from '../api/AxiosConfig';
import { Alert } from 'react-native';
import { buildBuildingId } from '../lib/propertyId';
import axiosInstance from '../api/AxiosConfig';

interface UserAppState {
  corpName?: string;
  propertyImageUrl: string;
  propertyName?: string;
  query?: string;
  unitId?: string;
  username?: string;
}

export interface ServiceRequest {
  created_date: string;
  category: {
    name: string;
    id: string;
  };
  sub_category?: {
    name: string;
  };
  id: string;
  unit: string;
  description: string;
  brief_description: string;
  status: {
    name: string;
    id: string;
  };
  allow_suite_access: string;
}

type AppState = {
  user: UserAppState;
  // object 's too large,tempory leave it to object.
  userData: Object;
  isLoading: boolean;
  services: Array<ServiceRequest>;
  modalName?: string;
  modalProps?: any;
  isShowModal?: boolean;
  currentUser: any;
  dontShowContests: Array<number>;
  serviceRequestConfig: Object;
};

let initialState: AppState = {
  user: {
    corpName: '',
    propertyImageUrl: '',
    propertyName: '',
    query: '',
    unitId: '',
    username: '',
  },
  userData: {},
  isLoading: false,
  services: [],
  modalName: '',
  modalProps: {},
  isShowModal: false,
  currentUser: null,
  dontShowContests: [],
  serviceRequestConfig: {},
};

interface Field<V> {
  field: keyof UserAppState;
  value: V;
}

type AppStateUserPayload = {} & UserAppState;
type AppStateQueryPayload = { query: string };
type ServiceRequestConfigPayload = {} | ServiceRequestConfig;
type LoadingStatePayload = { isLoading: boolean };
type DontShowContestStatePayload = { id: number };

type LoginPayload = {
  userData: object;
  curretUser: object;
};
type UserDataPayload = {
  userData: object;
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCurrentUser(state, action: PayloadAction<AppStateUserPayload>) {
      debug('setCurrentUser');
      debug(action);
      state.user = { ...action.payload };
    },
    setUserField(state, action: PayloadAction<Field<string>>) {
      const { field, value } = action.payload;
      debug(`setting user field ${field}: ${value}`);
      state.user[field] = value;
    },
    setCurrentQuery(state, action: PayloadAction<AppStateQueryPayload>) {
      debug('setCurrentQuery');
      debug(action);
      state.user.query = action.payload.query;
    },
    setServiceRequestConfig(
      state,
      action: PayloadAction<ServiceRequestConfigPayload>,
    ) {
      debug('setServiceRequestConfig');
      debug(action);
      state.serviceRequestConfig = { ...action.payload };
    },
    clearCurrentQuery(state) {
      debug('clearCurrentQuery');
      state.user.query = '';
    },
    loginSucess(state, action: PayloadAction<LoginPayload>) {
      state.userData = action.payload.userData;
      state.currentUser = action.payload.curretUser;
    },
    userLogout(state) {
      state.user.corpName = '';
      state.userData = initialState.userData;
      state.currentUser = null;
    },
    setLoading(state, action: PayloadAction<LoadingStatePayload>) {
      state.isLoading = action.payload.isLoading;
    },
    setServices(state, action: any) {
      state.services = action.payload;
    },
    showModal(state, action: PayloadAction<RootModalProps>) {
      state.modalName = action.payload.modalName;
      state.modalProps = action.payload.modalProps;
      state.isShowModal = action.payload.isShowModal;
    },
    hideModal(state) {
      state.modalName = '';
      state.modalProps = {};
      state.isShowModal = false;
    },
    setUserData(state, action: PayloadAction<UserDataPayload>) {
      state.userData = action.payload.userData;
    },
    addDontShowContest(
      state,
      action: PayloadAction<DontShowContestStatePayload>,
    ) {
      if (!state.dontShowContests) {
        state.dontShowContests = [];
      }
      console.log(`add dont show contest:${action.payload.id}`);
      if (!state.dontShowContests.includes(action.payload.id)) {
        state.dontShowContests.push(action.payload.id);
      }
    },
    removeDontShowContest(
      state,
      action: PayloadAction<DontShowContestStatePayload>,
    ) {
      if (!state.dontShowContests) {
        state.dontShowContests = [];
      }
      const index = state.dontShowContests.indexOf(action.payload.id);
      if (index > -1) {
        state.dontShowContests.splice(index, 1);
      }
    },
  },
});

export const {
  setCurrentQuery,
  setCurrentUser,
  clearCurrentQuery,
  setUserField,
  loginSucess,
  userLogout,
  setLoading,
  setServices,
  showModal,
  hideModal,
  setUserData,
  addDontShowContest,
  removeDontShowContest,
  setServiceRequestConfig,
} = appSlice.actions;

export const selectCurrentUser = createSelector(
  (state: RootState) => state.app,
  (appState: AppState) => {
    debug('selectCurrentUser currentUser is:');
    debug(appState.user);
    return {
      ...appState.user,
    };
  },
);

export const selectUserData = createSelector(
  (state: RootState) => state.app,
  (appState: AppState) => appState.userData,
);

export const selectServiceRequestConfig = createSelector(
  (state: RootState) => state.app,
  (appState: AppState) => appState.serviceRequestConfig,
);

export const selectCurrenUser = createSelector(
  (state: RootState) => state.app,
  (appState: AppState) => appState.currentUser,
);

export const selectDontShowContests = createSelector(
  (state: RootState) => state.app,
  (appState: AppState) => appState.dontShowContests,
);

export const selectServiceRequests = createSelector(
  (state: RootState) => state.app,
  (appState: AppState) => appState.services,
);

export const selectIsLoading = createSelector(
  (state: RootState) => state.app,
  (appState: AppState) => appState.isLoading,
);

function showProfileError() {
  Alert.alert(
    'Error',
    'Unable to load user profile data. Please try again. If the problem persists please contact property management.',
    [
      {
        text: 'OK',
        onPress: () => {},
      },
    ],
    { cancelable: true },
  );
}

function showPropertyError() {
  Alert.alert(
    'Error',
    'Unable to load property management data. Please try again. If the problem persists please contact property management.',
    [
      {
        text: 'OK',
        onPress: () => {},
      },
    ],
    { cancelable: true },
  );
}

export const requestLogin = (
  values: any,
  actions: any,
  isFetchBuilding: boolean,
): AppThunk => {
  return async (dispatch) => {
    try {
      const user = await Auth.signIn(values.email, values.password, {
        appId: 'com.zonetail.pms',
      });
      const token = _get(user, 'signInUserSession.accessToken.jwtToken', '');
      await AsyncStorage.setItem(Constant.TOKEN, token);
      // console.log('token is', JSON.stringify({token}));
      AxiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
      const res = await getUserProfileAPI();
      // console.log('requestLogin res', JSON.stringify(res));
      const result = _get(res, 'data.result', null);
      const pmsType = _get(res, 'data.pmsType', null);
      if (!result || !pmsType) {
        console.warn('requestLogin: data is not valid');
        actions.setSubmitting(false);
        actions.setErrors({ password: 'Unable to load data' });
        showProfileError();
        return;
      }
      //      console.log('requestLogin res', JSON.stringify(result, null, 2));
      console.log(
        'requestLogin getUserProfileAPI() res',
        JSON.stringify(res, null, 2),
      );

      let tCode;
      let property;
      let userData;
      let unitId;
      let yardiId;
      let yardiReferenceId;
      let yardiPropertyId;
      let propertyConfig;

      if (pmsType === 'zt') {
        console.log('pms type is zt');
        yardiId = null;
        userData = _get(result, 'user', {});
        unitId = _get(result, 'unit_id', '');
        tCode = _get(result, 'tcode');
        property = _get(result, 'property_id');
        console.log({
          yardiId,
          userData,
          unitId,
          tCode,
          property,
        });
        propertyConfig = await getHomePropertyConfig(property);
        console.log(
          'property config res',
          JSON.stringify(propertyConfig, null, 2),
        );
      } else {
        const { GetResidentDataResult } = result;
        ({ yardiId, yardiReferenceId, yardiPropertyId } = res.data);
        const error = _get(
          GetResidentDataResult,
          'MITS-ResidentData.Summary.Messages.Error',
          null,
        );
        if (error) {
          actions.setSubmitting(false);
          actions.setErrors({ password: 'Unable to load data (2)' });
          showProfileError();
          return;
        } else {
          // success
          userData = _get(
            GetResidentDataResult,
            'MITS-ResidentData.LeaseFiles.LeaseFile',
            null,
          );
          unitId = _get(userData, 'Unit.Identification.attributes.IDValue', '');
          tCode = _get(userData, 'Identification.attributes.IDValue', '');
          property = _get(
            userData,
            'Property.Identification.attributes.IDValue',
            '',
          );
          if (!userData || !unitId || !property) {
            actions.setSubmitting(false);
            actions.setErrors({ password: 'Unable to load data (3)' });
            showProfileError();
            return;
          }
          console.log('loading property config');
          propertyConfig = await getPropertyConfig(
            yardiPropertyId,
            property,
            yardiId,
            yardiReferenceId,
          );
          console.log(
            'property config res',
            JSON.stringify(propertyConfig, null, 2),
          );
          if (isEmpty(propertyConfig)) {
            console.warn('requestLogin: no property data');
            actions.setSubmitting(false);
            actions.setErrors({ password: 'Unable to load property data' });
            showPropertyError();
            return;
          }
        }
      }
      // console.log('user data is', JSON.stringify(userData, null, 2));
      await analytics.trackProperty(String(unitId), String(tCode), property);
      await analytics.trackLogin();
      await AsyncStorage.setItem(Constant.UNIT_ID, unitId);
      await AsyncStorage.setItem(Constant.IS_LOGGED_IN, String(true));
      await AsyncStorage.setItem(Constant.PROPERTY_ID, property);
      await AsyncStorage.setItem(Constant.USER_NAME, values.email);
      await AsyncStorage.setItem(Constant.PMS_TYPE, pmsType);

      await AsyncStorage.setItem(
        Constant.CONDO_CORP_ID,
        String(propertyConfig.id),
      );
      const propertyManagerId = _get(propertyConfig, 'property_manager.id', '');
      await AsyncStorage.setItem(
        Constant.PROPERTY_MANAGER_ID,
        String(propertyManagerId),
      );

      actions.setSubmitting(false);
      dispatch(
        loginSucess({
          curretUser: user,
          userData,
        }),
      );
      // MTCC3275 is a test value for explore
      const homePropertyId = _get(
        propertyConfig,
        'explore_condo_id',
        buildBuildingId(String(propertyConfig.id), String(property)),
      );
      if (homePropertyId) {
        await AsyncStorage.setItem(Constant.CONDO_CORP_NAME, homePropertyId);
      }
      await analytics.trackCorp(
        String(propertyConfig.id),
        String(yardiId),
        String(propertyConfig.yardi_property_id),
        String(homePropertyId),
      );
      dispatch(setUserField({ field: 'corpName', value: homePropertyId }));
      const zipPostal = await getZipcode(String(propertyConfig.id));
      await AsyncStorage.setItem(Constant.ZIP_POSTAL, zipPostal);
      // if (isFetchBuilding) {
      //   dispatch(loadBuilding(String(propertyConfig.id)));
      // }
      //      }
    } catch (error) {
      console.log({ error });
      actions.setErrors({
        password: 'Username and Password not found or unable to load property',
      });
      actions.setSubmitting(false);
    }
  };
};

function showUserDataLoadError() {
  Alert.alert(
    'Error',
    'Unable to load user profile data. Please try again. If the problem persists please contact property management.',
    [
      {
        text: 'OK',
        onPress: () => {},
      },
    ],
    { cancelable: true },
  );
}

export const fetchUserData = (userId: string): AppThunk => {
  return async (dispatch) => {
    try {
      const res = await getUserProfileAPI();
      // console.log('fetchUserData - res is', JSON.stringify({ res }));
      if (!res || !res.data || !res.data.result) {
        showUserDataLoadError();
        return;
      }
      const { GetResidentDataResult } = res.data.result;
      const error = _get(
        GetResidentDataResult,
        'MITS-ResidentData.Summary.Messages.Error',
        null,
      );
      if (error) {
        showUserDataLoadError();
        return;
      } else {
        // success
        const userData = _get(
          GetResidentDataResult,
          'MITS-ResidentData.LeaseFiles.LeaseFile',
          null,
        );
        dispatch(setUserData({ userData }));
      }
    } catch (error) {
      console.debug('ERROR With fetch user data', error);
      showUserDataLoadError();
      return;
      // TODO: write a common handleError function
    }
  };
};

export const actionLogout = (): AppThunk => {
  return async (dispatch) => {
    await Auth.signOut();
    await AsyncStorage.removeItem(Constant.TOKEN);
    delete axiosInstance.defaults.headers.common.Authorization;
    dispatch(userLogout());
  };
};

export const fetchServiceRequest = (): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setLoading({ isLoading: true }));
      const response = await getServiceRequestAPI();
      const results = _get(response, 'data.results', []);
      (results || []).sort((pre: any, next: any) => {
        const prevDate = new Date(pre.update_date);
        const nextDate = new Date(next.update_date);
        return (nextDate as any) - (prevDate as any);
      });
      dispatch(setServices(results));
      dispatch(setLoading({ isLoading: false }));
    } catch (e) {
      dispatch(setServices([]));
      dispatch(setLoading({ isLoading: false }));
    }
  };
};

export const fetchServiceRequestConfig = (): AppThunk => {
  return async (dispatch) => {
    try {
      const response = await getServiceRequestConfig();
      dispatch(setServiceRequestConfig(response));
    } catch (e) {
      debug('Error fetching service request config data');
      dispatch(setServiceRequestConfig({}));
    }
  };
};

export const signInWithCognito = (
  userName: string,
  password: string,
  res: any,
): AppThunk => {
  return async (dispatch) => {
    try {
      // console.log('signInWithCognito', JSON.stringify(res, null, 2));
      dispatch(setLoading({ isLoading: true }));
      const user = await Auth.signIn(userName, password, {
        appId: 'com.zonetail.pms',
      });
      const token = _get(user, 'signInUserSession.accessToken.jwtToken', '');
      if (!token) {
        console.warn('did not fetch token.  error');
        dispatch(setLoading({ isLoading: false }));
        showProfileError();
        return;
      }
      await AsyncStorage.setItem(Constant.TOKEN, token);
      AxiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;

      console.log('signinwithcognitio.   res is:', JSON.stringify(res));

      const userData = _get(
        res,
        'data.GetResidentDataResult.MITS-ResidentData.LeaseFiles.LeaseFile',
        null,
      );
      const unitId = _get(
        userData,
        'Unit.Identification.attributes.IDValue',
        '',
      );
      const property = _get(
        userData,
        'Property.Identification.attributes.IDValue',
        '',
      );

      /*
      profile: {
        yardiId: 4,
        propertyId: "zonetal1",
        tCode: "t0050117",
      }
      */

      if (!userData || !unitId || !property) {
        console.warn(
          `no userData or unitId or property ${userData}, ${unitId}, ${property}`,
        );
        dispatch(setLoading({ isLoading: false }));
        showProfileError();
        return;
      }
      await AsyncStorage.setItem(Constant.IS_LOGGED_IN, String(true));
      await AsyncStorage.setItem(Constant.USER_NAME, userName);
      await AsyncStorage.setItem(Constant.UNIT_ID, unitId);
      await AsyncStorage.setItem(Constant.PROPERTY_ID, property);

      const { yardiId, yardiReferenceId, yardiPropertyId } = res.profile;

      const propertyConfig = await getPropertyConfig(
        yardiPropertyId,
        property,
        yardiId,
        yardiReferenceId,
      );
      if (isEmpty(propertyConfig)) {
        console.warn('requestLogin: no property data');
        dispatch(setLoading({ isLoading: false }));
        showPropertyError();
        return;
      }
      console.log('property config res', JSON.stringify(propertyConfig));
      await AsyncStorage.setItem(
        Constant.CONDO_CORP_ID,
        String(propertyConfig.id),
      );
      const homePropertyId = _get(
        propertyConfig,
        'explore_condo_id',
        buildBuildingId(String(propertyConfig.id), String(property)),
      );
      if (homePropertyId) {
        await AsyncStorage.setItem(CONDO_CORP_NAME, homePropertyId);
      }

      dispatch(
        loginSucess({
          curretUser: user,
          userData,
        }),
      );
      dispatch(setUserField({ field: 'corpName', value: homePropertyId }));
      dispatch(setLoading({ isLoading: false }));
    } catch (error) {
      console.error('signInWithCognito error', error);
      dispatch(setLoading({ isLoading: false }));
      showProfileError();
    }
  };
};

export const registerPushNotification =
  (params: any): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setLoading({ isLoading: true }));
      const { suite_id, property_id, subscription_name } = params;
      await registerPushNotificationAPI(params);
      await subscribePushNotificationAPI({
        suite_id,
        property_id,
        subscription_name,
      });
      dispatch(setLoading({ isLoading: false }));
    } catch (error) {
      console.error(error);
      Alert.alert(
        'Error',
        'Unable to subscribe to push notifications. Please try again. If the problem persists please contact property management.',
        [
          {
            text: 'OK',
            onPress: () => {},
          },
        ],
        { cancelable: true },
      );
      dispatch(setLoading({ isLoading: false }));
    }
  };

export default appSlice.reducer;
